import { render, staticRenderFns } from "./stars.vue?vue&type=template&id=5e861452&lang=true&"
import script from "./stars.vue?vue&type=script&lang=js&"
export * from "./stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports